import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import {Helmet} from "react-helmet";

import Member from '../../components/team/Member';
import teamdata from '../../data/team';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import './Team.css';

class Team extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            member: {}
        };
    }

    selectMember(member) {
        this.setState({
            openModal: true,
            member: member
        });
    }

    closeModal() {
        this.setState({
            openModal: false,
            member: {}
        });
    }

    renderMemberDetail() {
        const selectedMember = this.state.member;
        if (Object.keys(selectedMember).length > 0) {
            return (
                <div className="team-member-details">
                    <div className="intro">
                        <img alt={ selectedMember.name } className="lazyload" data-src={ selectedMember.image } />
                        <div className="name-and-title">
                            <div className="name">{ selectedMember.name }</div>
                            <div className="title">{ selectedMember.title }</div>
                        </div>
                    </div>
                    <div className="bio">{ selectedMember.bio.split("<br>").map((p, i) => <p key={ i }>{ p }</p>) }</div>
                </div>
            );
        }
        return null;
    }

    render() {
        const teamMembers = teamdata.team.map((member, index) => <Member key={ index } member={ member } selectMember={ this.selectMember.bind(this) } />);
        const advisors = teamdata.advisors.map((advisor, index) => <Member key={ index } member={ advisor } selectMember={ this.selectMember.bind(this) } />);
        return (
            <div className="team">
                <Helmet>
                    <title>Meet the Team - HelloAva</title>
                    <meta name="description" content="Meet the brains behind HelloAva! Skin care suggestions and routines made with love in NYC." />
                </Helmet>
                <div className="banner">
                    <div className="big-message">The Brains Behind</div>
                    <div className="big-message">HelloAva</div>
                    <div className="small-message">Made with &#9829; in NYC</div>
                </div>
                <div className="container">
                    <div className="section">
                        <div className="title-container">
                            <div className="section-title">Team</div>
                        </div>
                        <div className="members">{ teamMembers }</div>
                    </div>
                    <div className="section">
                        <div className="section-title">Advisors</div>
                        <div className="members">{ advisors }</div>
                    </div>
                </div>
                <Modal open={ this.state.openModal } onClose={ this.closeModal.bind(this) } little={ true }
                    classNames={{ overlay: 'ha-overlay', modal: 'ha-modal' }}>
                    { this.renderMemberDetail() }
                </Modal>
            </div>
        );
    }
}

export default withRouter(Team);



// WEBPACK FOOTER //
// ./src/views/team/Team.js